// extracted by mini-css-extract-plugin
export default {"tabList":"Pricelists__tabList___W7Yf7","tabItem":"Pricelists__tabItem___chvQ4"};